import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const WordReadabilityStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    '.wrap-tabs': {
        height: 80
    }
}));

export const WordFrequencyStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    flexGrow: 1,
    overflow: "auto",
    '.table': {
        height: "100%",
            overflow: "auto"
    },
}));

export const ErrorFrequencyStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
}));
